import { makeAutoObservable } from "mobx"
import Store from ".."
import LoyaltyStoreX from "../loyalty"
import { createOrderReview } from "../../api/users"
import { createPayment, deleteOrder, getMyOrders, updateOrder } from "../../api/orders"
import { isNullOrUndefined } from "../../utils"
import { message } from "antd"

export default class OrdersApiStore {

  mainStore: Store
  loyaltyStore: LoyaltyStoreX

  ordersList: any[] = []
  selectedOrder: any | null = null

  isPaymentModalVisible: boolean = false
  isOrdersLoading: boolean = true
  isGetLoading: boolean = false
  isRevLoading: boolean = false
  isGetDone: boolean = false
  isRevDone: boolean = false
  isReviewVisible: boolean = false
  isPaymentCreated: boolean = false
  isOrderCancelVisible: boolean = false
  
  rating: number = 5
  reviewText: string = ""
  addressValue: string = ""
  payUrl: string = "#"

  constructor(main: Store, loyalty: LoyaltyStoreX) {
    makeAutoObservable(this)

    this.mainStore = main
    this.loyaltyStore = loyalty
  }

  public setSelectedOrder = (val: any) => this.selectedOrder = val
  public setRating = (val: number) => this.rating = val
  public setReviewText = (val: string) => this.reviewText = val
  public setAddressValue = (val: string) => this.addressValue = val
  public setPayUrl = (val: string) => this.payUrl = val

  public setIsOrderCancelVisible = (val: boolean) => this.isOrderCancelVisible = val
  public setIsPaymentModalVisible = (val: boolean) => this.isPaymentModalVisible = val
  public setIsPaymentCreated = (val: boolean) => this.isPaymentCreated = val
  public setIsReviewVisible = (val: boolean) => this.isReviewVisible = val
  public setIsRevDone = (val: boolean) => this.isRevDone = val
  public setIsGetDone = (val: boolean) => this.isGetDone = val
  public setIsRevLoading = (val: boolean) => this.isRevLoading = val
  public setIsGetLoading = (val: boolean) => this.isGetLoading = val
  public setIsOrdersLoading = (val: boolean) => this.isOrdersLoading = val

  public setOrdersList(val: any[]) {
    this.ordersList = val
  }

  public async fetchOrders() {
    this.setIsOrdersLoading(true)

    const res = await getMyOrders({
      page: 0, limit: 100, orderBy: "id", order: "DESC", search: ""
    })

    let lst: any[] = (res.orders ?? []).map((v: any) => {
      return {...v, loading: false}
    })

    lst = lst.sort((a, b) => {
      return a.status > b.status ? 1 : (a.status < b.status ? -1 : 0)
    })

    this.setOrdersList(lst.filter(v => v.status >= 0))
  
    this.setIsOrdersLoading(false)

    return true
  }

  public async sendReview() {
    if (this.selectedOrder === null)
      return false

    this.setIsReviewVisible(false)
    this.setIsRevLoading(false)

    await createOrderReview({
      order_id: this.selectedOrder.id,
      rating: this.rating,
      review: this.reviewText,
      status: 0
    })

    this.fetchOrders()

    this.setIsRevLoading(false)
    this.setIsRevDone(true)

    message.success("Вы успешно оставили отзыв!")

    return true
  }

  public clearOrdersLoading() {
    let newLst = this.ordersList.map(v => {
      return {...v, loading: false}
    })
    this.setOrdersList(newLst)
  }

  public async createPayment(order: any) {
    if (order.loading) {
      return
    }

    let newLst = this.ordersList.map(v => {
      if (v.id === order.id) {
        return {...v, loading: true}
      }
      return v
    })
    this.setOrdersList(newLst)

    const res = await createPayment({order_id: order.id})

    if (res.state === 0) {
      this.clearOrdersLoading()
      return {state: 0, message: res.message}
    }

    // if (isNullOrUndefined(res.type)) {
    //   this.clearOrdersLoading()
    //   this.fetchOrders()
    //   return {state: 0, message: "Не указан провайдер платежа!"}
    // }

    // if (!isNullOrUndefined(res.payment)) {
    //   this.clearOrdersLoading()
    //   return {state: 0, message: "Чтобы оплатить заказ привяжите карту!"}
    // }
    // this.setIsPaymentModalVisible(true)
    
    if (isNullOrUndefined(res.payment)) {
      this.fetchOrders()
      this.clearOrdersLoading()
    }

    return {state: 1, ...res}
  }

  public async cancelOrder() {
    if (this.selectedOrder === null)
      return false

    this.setIsOrderCancelVisible(false)

    await deleteOrder(this.selectedOrder.id)

    this.fetchOrders()

    message.success("Заказ успешно отменен!")

    return true
  }

  public async iAmGetOrder(order: any) {
    this.setIsGetLoading(true)

    await updateOrder(order.id, {status: 5})

    message.success("Вы подтвердили получение заказа!")

    this.fetchOrders()

    this.setIsGetLoading(false)

    setTimeout(() => {
      this.setSelectedOrder(order)
      this.setIsReviewVisible(false)
    }, 500)

    return true
  }

  public async saveAddress(address: string) {
    if (this.selectedOrder === null) {
      return false
    }

    console.log("this.selectedOrder")
    console.log(this.selectedOrder.id)

    await updateOrder(this.selectedOrder.id, { address: address })
    message.success("Адрес успешно обновлен!")
    this.fetchOrders()

    return true
  }

  public getOrderStatus(order: any) {
    if (order.status === 1) {
      return "Заказ в обработке"
    } else if (order.status === 2) {
      return "Собираем Ваш заказ"
    } else if (order.status === 3) {
      return "Доставляем заказ до филиала"
    } else if (order.status === 4 || order.status === 5) {
      return "Заказ доставлен в филиал"
    } else if (order.status === 6) {
      return "Заказ получен"
    }
  }

}